export default __webpack_public_path__ + "static/silverStag-7fa8dd7005d79271f766ed5b19f9878a.png";